import { forwardRef } from "react";
import { DropDown } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";
import { useDueDatesAuth } from "../../hooks/useDueDatesAuth";

export const AssigneeDropDown = forwardRef(
  ({ change, boardPermissions, initialValue, id }, ref) => {
    const { t, i18n } = useTranslation(["CreateTaskModal", "Shared"]);
    const { UserId } = useDueDatesAuth();

    let userData = [
      {
        Id: "",
        FullName: t("Shared:Unassigned"),
      },
    ];

    boardPermissions?.Entities.forEach((permission) => {
      userData.push(permission);
    });

    const initialValueAgain =
      initialValue ?? userData?.find((x) => x.Id == UserId)?.Id;

    const fields = {
      text: "FullName",
      value: "Id",
    };
    const handleOnChange = (e) => {
      change?.(e);
    };

    return (
      <DropDown
        value={initialValueAgain}
        ref={ref}
        name="AssigneeId"
        dataSource={userData?.filter((x) => x.FullName) ?? []}
        fields={fields}
        htmlFor={id}
        id={id}
        label={t("AssigneeLabel")}
        errorMessage={t("ErrorMsg")}
        locale={i18n?.language}
        change={handleOnChange}
        sortOrder="Ascending"
        allowFiltering
      />
    );
  }
);
